// The Javascript to open our search menu on mobile
// const searchToggle = document.querySelector("a.search-toggle")
// const searchClose = document.querySelector("a.search-btn-close")
const searchDarkBackground =  document.querySelector("div.search-dark-background")
const searchBarTag = document.querySelector("div.search-bar")


document.querySelectorAll("a.search-toggle").forEach(elem => elem.addEventListener("click",
 () => {
    searchBarTag.classList.toggle('search-open')
    searchDarkBackground.classList.toggle('visible')
    }));
  

    document.querySelectorAll("a.close-search-toggle").forEach(elem => elem.addEventListener("click",
 () => {
    searchBarTag.classList.toggle('search-open')
    searchDarkBackground.classList.toggle('visible')
        }));
    

// Here I close the search bar when I click on the dark background
searchDarkBackground.addEventListener("click", function () {
searchBarTag.classList.toggle('search-open')
searchDarkBackground.classList.toggle('visible')
})

// $(document).ready(function() {
//     let 
//     searchInputSelector = '.js-search-input',
//     searchSubmitSelector = '.js-search-submit',
//     onSearchInputKeyup = function(event) {
//         let
//         $form = $(this).closest('form'),
//         $button = $form.find(searchSubmitSelector),
//         shouldDisableButton = this.value.length === 0;

//         $button.prop('disabled', shouldDisableButton);
//     };

//     // Trigger the keyup event on page load
//     $(searchInputSelector).trigger('keyup');

//     $(document).on('keyup', searchInputSelector, onSearchInputKeyup);

//     // Add an additional event listener for input changes to handle deletion
//     $(document).on('input', searchInputSelector, onSearchInputKeyup);
// });


// document.addEventListener('DOMContentLoaded', function() {
//     const searchDarkBackground = document.querySelector("div.search-dark-background");
//     const searchBarTag = document.querySelector("div.search-bar");

//     document.querySelectorAll("a.search-toggle").forEach(elem => elem.addEventListener("click", () => {
//         searchBarTag.classList.toggle('search-open');
//         searchDarkBackground.classList.toggle('visible');
//     }));

//     document.querySelectorAll("a.close-search-toggle").forEach(elem => elem.addEventListener("click", () => {
//         searchBarTag.classList.toggle('search-open');
//         searchDarkBackground.classList.toggle('visible');
//     }));

//     searchDarkBackground.addEventListener("click", function () {
//         searchBarTag.classList.toggle('search-open');
//         searchDarkBackground.classList.toggle('visible');
//     });

//     let searchInputSelector = '.js-search-input',
//         searchSubmitSelector = '.js-search-submit',
//         onSearchInputKeyup = function(event) {
//             let $form = $(this).closest('form'),
//                 $button = $form.find(searchSubmitSelector),
//                 shouldDisableButton = this.value.length === 0;

//             $button.prop('disabled', shouldDisableButton);
//         };

//     // Trigger the keyup event on page load
//     $(searchInputSelector).trigger('keyup');

//     $(document).on('keyup', searchInputSelector, onSearchInputKeyup);
//     $(document).on('input', searchInputSelector, onSearchInputKeyup);
// });

// document.addEventListener("DOMContentLoaded", function() {
//     const searchInputSelector = '.js-search-input';
//     const searchSubmitSelector = '.js-search-submit';

//     const onSearchInputKeyup = function(event) {
//         const form = this.closest('form');
//         const button = form.querySelector(searchSubmitSelector);
//         const shouldDisableButton = this.value.trim().length === 0;

//         button.disabled = shouldDisableButton;
//     };

//     // Trigger the keyup event on page load to set the initial state
//     document.querySelectorAll(searchInputSelector).forEach(input => {
//         onSearchInputKeyup.call(input);
//     });

//     // Attach event listeners
//     document.addEventListener('keyup', function(event) {
//         if (event.target.matches(searchInputSelector)) {
//             onSearchInputKeyup.call(event.target);
//         }
//     });

//     document.addEventListener('input', function(event) {
//         if (event.target.matches(searchInputSelector)) {
//             onSearchInputKeyup.call(event.target);
//         }
//     });
// });


window.addEventListener("load", function() {
    // Selector for the search input and button
    const searchInputSelector = '.js-search-input';
    const searchSubmitSelector = '.js-search-submit';

    // Function to handle enabling/disabling the button
    const onSearchInputChange = function(event) {
        console.log('Input change detected'); // Debugging
        let form, button;

        if (this.closest) {
            form = this.closest('form');
        } else {
            // Fallback for browsers that don't support closest()
            form = findAncestor(this, 'form');
        }

        if (form) {
            button = form.querySelector(searchSubmitSelector);
        }

        if (button) {
            // Disable button if input is empty
            const shouldDisableButton = this.value.trim().length === 0;
            button.disabled = shouldDisableButton; 
            console.log('Button should be disabled:', shouldDisableButton); // Debugging
        } else {
            console.log('Button not found'); // Debugging
        }
    };

    // Helper function to find ancestor element
    function findAncestor(el, sel) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel)));
        return el;
    }

    // Use event delegation
    document.addEventListener('input', function(event) {
        if (event.target.matches(searchInputSelector)) {
            onSearchInputChange.call(event.target);
        }
    });

    // Check initial state on page load
    document.querySelectorAll(searchInputSelector).forEach(input => {
        onSearchInputChange.call(input);
    });

    // Feature detection
    if (!Element.prototype.closest) {
        console.log('closest() method not supported');
    }
});
















